"use strict";

exports.__esModule = true;
exports.returnEmptyObjectIfUndefined = exports.returnEmptyArrayIfUndefined = void 0;
var returnEmptyObjectIfUndefined = exports.returnEmptyObjectIfUndefined = function returnEmptyObjectIfUndefined(obj) {
  return obj === undefined ? {} : obj;
};
var returnEmptyArrayIfUndefined = exports.returnEmptyArrayIfUndefined = function returnEmptyArrayIfUndefined(arr) {
  return arr === undefined ? [] : arr;
};